import ReactDOM from 'react-dom';

const PortalLabModalWrapper = ({ children }) => {
  if (typeof window === 'undefined') return null; // SSR safety
  return ReactDOM.createPortal(children, document.body);
};

export default PortalLabModalWrapper;
